"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messages_1 = require("../messages");
var __1 = require("..");
var PHONE_NUMBER_REGEX = /^(0{0,2}|\+|[1-9])[1-9]\d*$/;
exports.validPhoneNumber = function (minLength, message) {
    return __1.createValidator(function (phoneNumber) {
        if (!phoneNumber) {
            return true;
        }
        phoneNumber = phoneNumber.replace(/ /g, "");
        if (phoneNumber.length < minLength) {
            return false;
        }
        return PHONE_NUMBER_REGEX.test(phoneNumber);
    }, message || messages_1.INVALID_PHONE_NUMBER);
};
